/* eslint-disable @typescript-eslint/no-unsafe-call */
import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import Field from '@/packages/field';
import { trimAll, trimValue } from '@/shared/utils/trim';
import UserPersonalInfoApi from '@/api/userPersonalInfo';
import { validatorPersonName } from '@/shared/utils/validator';
import { handleImportClick } from '@/shared/utils/contactImport/handleImport';
import { shouldShowContactImportIcon } from '@/views_v2/verify-credit/show-contact-icon';
import { ubtSetupModuleExpose } from '@/shared/utils/ubt/ubt-setup';
import { TP_CONTACT_IMPORT_SUCCESS } from '@/views_v2/verify-credit/tianqi';
import store from '@/store';
import { InfoComplementField } from '../../types';

const style = require('./index.module.scss') as Dictionary;

@Component({ name: 'ContactName' })
export default class ContactName extends Vue implements InfoComplementField {
  @Prop()
  private value!: string;

  @Prop()
  private itemIndex!: number;

  @Prop()
  private nameTip!: boolean;

  private contactName = '';

  private errorMsg = '';

  private get showImportIcon(): boolean {
    return !!(store.state.verifyCredit && store.state.verifyCredit.shouldShowContactImportIcon);
  }

  // 联系人姓名
  public async onValidator(): Promise<boolean> {
    const val = this.contactName;
    if (!val) {
      this.errorMsg = '请填写联系人的姓名';
      return false;
    }

    if (!(val && validatorPersonName(val))) {
      this.errorMsg = '联系人姓名只能包含2～25个汉字';
      return false;
    }

    if (!(val && this.checkSensitiveName(val))) {
      this.errorMsg = '联系人姓名不能包含敏感字符';
      return false;
    }

    if (!(val && await this.checkSameToUserName(val))) {
      this.errorMsg = '联系人姓名不能和用户姓名一致';
      return false;
    }

    return true;
  }

  private async created() {
    if (this.value) {
      this.contactName = this.value;
    }
    await shouldShowContactImportIcon();
  }

  @Watch('value')
  private onValueChange(val: string) {
    /** 删除空格字符 */
    this.contactName = trimAll(val);
  }

  /** 联系人姓名不能包含敏感字符 */
  private checkSensitiveName(val: string): boolean {
    const trimVal = trimValue(val);
    // 当前需要校验的联系人名字敏感字符
    const SentiveNameList = [
      '姥', '爷', '婆', '公', '奶',
      '爸', '妈', '叔', '姨', '舅',
      '哥', '兄', '姐', '弟', '妹',
      '丈夫', '老公', '老婆', '妻子', '媳妇',
      '父', '母', '伯', '婶', '姑',
      '婿', '嫂',
    ];
    const checkNameRes = SentiveNameList.find(
      (item) => trimVal.indexOf(item) > -1,
    );

    return !checkNameRes;
  }

  /** 联系人姓名不能和注册姓名一致 */
  private async checkSameToUserName(val: string): Promise<boolean> {
    const trimVal = trimValue(val);
    const { checkNameRes } = await UserPersonalInfoApi
      .checkUserContact({ contactName: trimVal }) || {};

    return !checkNameRes;
  }

  private onChange(val: string) {
    this.errorMsg = '';
    this.$emit('change', val);
  }

  /** 仅在哈啰app内且不包括鸿蒙系统，以及版本为6.98.70及以上，才允许导入联系人 */
  private async onImportClick() {
    const importedContactInfo = await handleImportClick();
    if (importedContactInfo) {
      this.onChange(importedContactInfo.name);
      // 传递 itemIndex标识第几个联系人
      this.$emit('importPhone', importedContactInfo.phone, this.itemIndex);
      ubtSetupModuleExpose(TP_CONTACT_IMPORT_SUCCESS);
    }
  }

  private render() {
    return (
      <div class={style.ContactName}>
        <div class={style.contractUpdate}>
          <div class={style.contactTitle}>
            <div class={style.contactIndex}>联系人{this.itemIndex}</div>
            {this.nameTip && <div class={style.contactTip}><i></i>请确认配偶信息</div>}
          </div>
        </div>
        <Field
          v-model={this.contactName}
          class={style.contactName}
          label="姓名"
          // sub={true}
          placeholder="填写联系人的姓名"
          type="text"
          onChange={this.onChange.bind(this)}
          error={this.errorMsg}
        >
          {this.showImportIcon && (
            <div slot="icon"
              class={style.contactNameIcon}
              onClick={this.onImportClick.bind(this)}
              />
          )}
        </Field>

      </div>
    );
  }
}
